import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { useSearchRecipesStore } from '~/composables/_next/stores/useSearchRecipesStore';
import { useTrpc } from '@/composables/_next/useTrpc';
import { fetchAllAverageReviews } from '~/helpers/reviewsRating';
import { useLocalization } from '~/composables/_next/useLocalization';
export function useRecipeListingStore() {
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale;
  var route = useRoute();
  var _useTrpc = useTrpc(),
    client = _useTrpc.client;
  var _useSearchRecipesStor = useSearchRecipesStore(),
    recipes = _useSearchRecipesStor.recipes,
    recipePagination = _useSearchRecipesStor.recipePagination,
    recipeFacets = _useSearchRecipesStor.recipeFacets,
    searchRecipes = _useSearchRecipesStor.searchRecipes,
    getRecipeSorting = _useSearchRecipesStor.getRecipeSorting;

  /**
   * Stores the current recipe listing from contentful
   */
  var recipeListingContent = useState("recipe-listing-content-".concat(route.params.slug), function () {
    return null;
  });
  var recipeListingStaticReviews = useState("recipe-listing-static-reviews-".concat(route.params.slug), function () {
    return null;
  });
  var recipeListingPagination = useState("recipe-listing-pagination-".concat(route.params.slug), function () {
    return null;
  });
  var recipeListingSort = useState("recipe-listing-sorting-".concat(route.params.slug), function () {
    return null;
  });
  var recipeListingFacets = useState("recipe-listing-facets-".concat(route.params.slug), function () {
    return null;
  });

  /**
   * Fetches the recipe listing and related items from contentful.
   */
  function fetchRecipeListingContent() {
    return _fetchRecipeListingContent.apply(this, arguments);
  }
  /**
   * Static recipe listing are defined manually in contentful while the others are fetched from attraqt.
   */
  function _fetchRecipeListingContent() {
    _fetchRecipeListingContent = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _content$data, _content$data$pageRec;
      var content, _recipeListingContent7, _recipeListingContent8, _recipeListingContent9, recipeIds;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.contentful.getRecipeListingPage.query({
              locale: locale,
              limit: 50,
              slug: route.params.slug
            });
          case 2:
            content = _context.sent;
            recipeListingContent.value = content === null || content === void 0 ? void 0 : (_content$data = content.data) === null || _content$data === void 0 ? void 0 : (_content$data$pageRec = _content$data.pageRecipeListCollection) === null || _content$data$pageRec === void 0 ? void 0 : _content$data$pageRec.items[0];
            if (!isStatic.value) {
              _context.next = 11;
              break;
            }
            recipeIds = recipeListingContent === null || recipeListingContent === void 0 ? void 0 : (_recipeListingContent7 = recipeListingContent.value) === null || _recipeListingContent7 === void 0 ? void 0 : (_recipeListingContent8 = _recipeListingContent7.recipesCollection) === null || _recipeListingContent8 === void 0 ? void 0 : (_recipeListingContent9 = _recipeListingContent8.items) === null || _recipeListingContent9 === void 0 ? void 0 : _recipeListingContent9.map(function (recipe) {
              return recipe.sys.id;
            });
            recipeListingPagination.value = getRecipeListingPagination(recipePagination.value);
            if (!(recipeIds !== null && recipeIds !== void 0 && recipeIds.length)) {
              _context.next = 11;
              break;
            }
            _context.next = 10;
            return fetchAllAverageReviews(recipeIds);
          case 10:
            recipeListingStaticReviews.value = _context.sent;
          case 11:
            return _context.abrupt("return", recipeListingContent.value);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchRecipeListingContent.apply(this, arguments);
  }
  var isStatic = computed(function () {
    var _recipeListingContent, _recipeListingContent2;
    return (recipeListingContent === null || recipeListingContent === void 0 ? void 0 : (_recipeListingContent = recipeListingContent.value) === null || _recipeListingContent === void 0 ? void 0 : (_recipeListingContent2 = _recipeListingContent.recipeTypeV2) === null || _recipeListingContent2 === void 0 ? void 0 : _recipeListingContent2.id) === 'custom';
  });

  /*
   * Fetches the recipe listing from Attraqt
   */
  function fetchRecipeListing(_x) {
    return _fetchRecipeListing.apply(this, arguments);
  }
  /**
   * Computed list of recipes.
   */
  function _fetchRecipeListing() {
    _fetchRecipeListing = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(forcedSort) {
      var _route$query$sort, _recipeListingContent0, _recipeListingContent1;
      var sort;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!isStatic.value) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            sort = (_route$query$sort = route.query.sort) !== null && _route$query$sort !== void 0 ? _route$query$sort : 'pertinence';
            if (forcedSort) sort = forcedSort;
            recipeListingSort.value = getRecipeListingSort(sort);
            _context2.next = 7;
            return searchRecipes((_recipeListingContent0 = recipeListingContent.value) === null || _recipeListingContent0 === void 0 ? void 0 : (_recipeListingContent1 = _recipeListingContent0.recipeTypeV2) === null || _recipeListingContent1 === void 0 ? void 0 : _recipeListingContent1.name, forcedSort);
          case 7:
            recipeListingPagination.value = getRecipeListingPagination(recipePagination.value);
            recipeListingFacets.value = getRecipeListingFacets(recipeFacets.value);
            return _context2.abrupt("return", recipeListing.value);
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _fetchRecipeListing.apply(this, arguments);
  }
  var recipeListing = computed(function () {
    var _recipeListingContent3, _recipeListingContent4;
    return !isStatic.value ? recipes.value : recipeListingContent === null || recipeListingContent === void 0 ? void 0 : (_recipeListingContent3 = recipeListingContent.value) === null || _recipeListingContent3 === void 0 ? void 0 : (_recipeListingContent4 = _recipeListingContent3.recipesCollection) === null || _recipeListingContent4 === void 0 ? void 0 : _recipeListingContent4.items.map(function (recipe) {
      var _recipeListingStaticR, _recipe$carouselColle, _recipe$carouselColle2, _recipe$carouselColle3, _recipe$cosmecticReci, _recipe$cosmecticReci2, _recipe$cosmecticReci3, _recipe$cosmecticReci4;
      var review = (_recipeListingStaticR = recipeListingStaticReviews.value) === null || _recipeListingStaticR === void 0 ? void 0 : _recipeListingStaticR[recipe.sys.id];
      return {
        recipeId: recipe.sys.id,
        title: recipe.title,
        url: recipe.slug,
        photo: (_recipe$carouselColle = recipe.carouselCollection) === null || _recipe$carouselColle === void 0 ? void 0 : (_recipe$carouselColle2 = _recipe$carouselColle.items) === null || _recipe$carouselColle2 === void 0 ? void 0 : (_recipe$carouselColle3 = _recipe$carouselColle2[0]) === null || _recipe$carouselColle3 === void 0 ? void 0 : _recipe$carouselColle3.url,
        category: (_recipe$cosmecticReci = recipe.cosmecticRecipeFamilyCollection) === null || _recipe$cosmecticReci === void 0 ? void 0 : (_recipe$cosmecticReci2 = _recipe$cosmecticReci.items) === null || _recipe$cosmecticReci2 === void 0 ? void 0 : (_recipe$cosmecticReci3 = _recipe$cosmecticReci2[0]) === null || _recipe$cosmecticReci3 === void 0 ? void 0 : (_recipe$cosmecticReci4 = _recipe$cosmecticReci3.parentFamilyV2) === null || _recipe$cosmecticReci4 === void 0 ? void 0 : _recipe$cosmecticReci4.title,
        rating: review === null || review === void 0 ? void 0 : review.averageRate,
        numReviews: review === null || review === void 0 ? void 0 : review.count
      };
    });
  });

  /**
   * Pagination data for the recipe listing.
   */
  function getRecipeListingPagination(recipePagination) {
    var _recipeListingContent5, _recipeListingContent6, _route$query;
    if (!isStatic.value) return recipePagination;
    var count = recipeListingContent === null || recipeListingContent === void 0 ? void 0 : (_recipeListingContent5 = recipeListingContent.value) === null || _recipeListingContent5 === void 0 ? void 0 : (_recipeListingContent6 = _recipeListingContent5.recipesCollection) === null || _recipeListingContent6 === void 0 ? void 0 : _recipeListingContent6.total;
    var pages = Math.ceil(count / 24);
    return {
      current: (_route$query = route.query) !== null && _route$query !== void 0 && _route$query.page ? parseInt(route.query.page.toString()) : 1,
      pages: pages,
      count: count
    };
  }

  /**
   * Gets the recipe listing sort.
   *
   * @param      {string}  sort    The sort
   * @return     {object}  The recipe listing sort.
   */
  function getRecipeListingSort(sort) {
    var recipeSorting = getRecipeSorting(sort);
    return isStatic.value ? null : recipeSorting;
  }

  /**
   * Gets the recipe listing facets.
   *
   * @param      {object}  recipeFacets  The recipe facets
   * @return     {object}  The recipe listing facets.
   */
  function getRecipeListingFacets(recipeFacets) {
    return isStatic.value ? null : recipeFacets;
  }
  return {
    recipeListingPagination: recipeListingPagination,
    recipeListingFacets: recipeListingFacets,
    recipeListingSort: recipeListingSort,
    fetchRecipeListingContent: fetchRecipeListingContent,
    recipeListingContent: recipeListingContent,
    fetchRecipeListing: fetchRecipeListing,
    recipeListing: recipeListing,
    isStatic: isStatic
  };
}